<template>
    <div>
        <h3 v-b-tooltip.hover="`（${detailForm?.name}）`" class="text-truncate" style="position: absolute; top: -40px; left: 40px">
            （{{ detailForm?.name }}）
        </h3>
        <div class="card-header">
            <div class="d-flex">
                <div class="title--screen" style="white-space: nowrap">
                    {{ $t('managerForm.analytics.titleDataManageMail') }}
                </div>
            </div>
        </div>
        <div class="card-body">
            <template>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 120px">{{ $t('managerForm.analytics.startTimeRange') }}</label>
                    <div class="col-sm-9">
                        <div class="d-flex" style="gap: 1rem">
                            <DateNormal :full_date.sync="initDataSearch.from.created_at"> </DateNormal>
                            <span class="mt-2">～</span>
                            <DateNormal :full_date.sync="initDataSearch.to.created_at"> </DateNormal>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 120px">{{ $t('managerForm.analytics.typeData') }}</label>
                    <div class="col-sm-9 d-flex">
                        <div v-for="(itemType, idx) in TYPE_DATA_EXPORT" :key="itemType.name">
                            <InputCheckBox
                                style="min-width: 100px"
                                :model.sync="initDataSearch.is_submitted"
                                :id="`searchEmailEmpty-${idx}`"
                                :value="itemType.value"
                                :label="itemType.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 120px">メールアドレス</label>
                    <div class="col-sm-9 d-flex">
                        <InputText
                            style="min-width: 200px"
                            :model.sync="initDataSearch.email"
                            :id="`searchEmail}`"
                            :config="{ placeholder: 'メールアドレス' }"
                        />
                    </div>
                </div>
                <div class="text-center text-nowrap">
                    <button type="button" @click="handleClearSearch" class="btn btn-common btn-outline-primary">
                        <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
                    </button>
                    <button type="button" @click="getList" class="btn btn-common btn-primary ml-3">
                        <i class="ri-search-line"></i>{{ $t('btn.search') }}
                    </button>
                </div>
            </template>
            <template>
                <h3 class="mb-0 title--screen">
                    回答結果 <span>件数 ({{ configPage.total }})</span>
                </h3>
                <div class="d-flex justify-content-end mb-2">
                    <button type="button" class="btn btn-common btn-success" @click="() => (configModalDownloadData.model = true)">
                        <i class="ri-file-download-line"></i>データダウンロード
                    </button>
                </div>
                <TableListComponent
                    :heightTable="`calc(100vh - 600px)`"
                    :config="configTable"
                    :dataList="listDataTable"
                    :isLoading="isLoading"
                    :configPage.sync="configPage"
                    :stickyAction="true"
                    @onChangePage="getList()"
                    class="table-send-mail"
                >
                    <template #row="{ row }">
                        <tr>
                            <td>{{ row.submit_index }}</td>
                            <td class="text-left el-table__cell">{{ row.email }}</td>
                            <td class="text-left el-table__cell">
                                <a :href="row.token_url" target="_blank">{{ row.token_url }}</a>
                            </td>
                            <td>
                                <div class="text-left el-table__cell">
                                    {{ formatDateCommon(row?.created_at, 'dateTimeJP') }}
                                </div>
                            </td>
                            <td>
                                <div class="text-left el-table__cell">
                                    {{ formatDateCommon(row?.expires_at, 'dateTimeJP') }}
                                </div>
                            </td>
                        </tr>
                    </template>
                </TableListComponent>
            </template>
        </div>
        <ModalCommon id="ModalDownloadData" :config="configModalDownloadData" @close="() => (configModalDownloadData.model = false)">
            <DownloadData
                type="mail"
                :detailForm="detailForm"
                :queryTableFilter="getQueryString()"
                :isSubmitted="initDataSearch.is_submitted"
                :configModal="configModalDownloadData"
            />
        </ModalCommon>
    </div>
</template>

<script>
import { InputCheckBox, InputText } from '@/components/Input';
import { TYPE_DATA_EXPORT } from '../download-data/constants';
import { configs } from '../../constants';
import { managerFormMethods } from '@/state/helpers';
import { formatDateCommon } from '@/utils/format';
import ModalCommon from '@/components/Modal/main.vue';
import DownloadData from '../download-data/main.vue';

import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import TableListComponent from '@/components/TableList/main.vue';

export default {
    name: 'DataMailSend',
    props: {
        detailForm: {
            type: Object,
            default: () => ({})
        }
    },
    components: { InputCheckBox, DateNormal, TableListComponent, InputText, ModalCommon, DownloadData },
    data() {
        return {
            TYPE_DATA_EXPORT,
            initDataSearch: this.initSearch(),
            configPage: configs.configPage,
            configTable: configs.configTableMailSend(),
            listDataTable: [],
            isLoading: false,
            configModalDownloadData: configs.configModalDownloadData
        };
    },
    methods: {
        ...managerFormMethods,
        formatDateCommon,

        initSearch() {
            return {
                is_submitted: [0, 1],
                from: {
                    created_at: null
                },
                to: {
                    created_at: null
                },
                email: ''
            };
        },

        handleClearSearch() {
            this.initDataSearch = this.initSearch();
            this.getList();
        },

        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            let copyDataSearch = Object.assign({}, this.initDataSearch);
            for (const [key, value] of Object.entries(copyDataSearch)) {
                if (key && value) {
                    if (['is_submitted'].includes(key)) {
                        query.push(`filters[${key}]=${decodeURIComponent(value)}`);
                    } else if (['from'].includes(key)) {
                        for (const [fromKey, fromValue] of Object.entries(value)) {
                            if (fromKey && fromValue) query.push(`from[${fromKey}]=${fromValue}`);
                        }
                    } else if (['to'].includes(key)) {
                        for (const [toKey, toValue] of Object.entries(value)) {
                            if (toKey && toValue) query.push(`to[${toKey}]=${toValue}`);
                        }
                    } else if (['email'].includes(key)) {
                        query.push(`search[${key}]=${value}`);
                    }
                }
            }
            return query.join('&');
        },

        async getList() {
            let query = this.getQueryString();
            this.isLoading = true;
            try {
                const data = await this.getRegisterEmailsAnalytics({ id: this.$route.query.id, query: query });
                this.listDataTable = data.data ?? [];
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listDataTable.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        }
    },

    mounted() {
        this.getList();
    }
};
</script>

<style lang="scss" scoped>
.table-send-mail {
    min-height: unset !important;
    height: auto !important;
}
</style>
